export const ADMIN = 'Admin';
export const CITY_HALL = 'City Hall';
export const AJPIS = 'AJPIS';
export const ASSOCIATION = 'Association';
export const BACK_OFFICE = 'Back office';
export const CRC = 'CRC';
